import { NgModule } from '@angular/core'
import { CommonModule } from '@angular/common'
import { ButtonRowLayoutComponent } from './button-row-layout.component'

@NgModule({
  imports: [CommonModule],
  declarations: [ButtonRowLayoutComponent],
  exports: [ButtonRowLayoutComponent]
})
export class ButtonRowLayoutModule {}
